import vsbl from 'vsbl';
import 'url-search-params-polyfill';
import app from 'app';

/* eslint-disable */
export function sortByArray(array, order, key) {
  array.sort((a, b) => {
    const A = a[key]; const
      B = b[key];

    if (order.indexOf(A) > order.indexOf(B)) {
      return 1;
    }
    return -1;
  });

  return array;
}

function compare(a, b, numb) {
  let comparison = 0;

  if (a > b) comparison = 1;
  else if (a < b) comparison = -1;

  return comparison * numb;
}

export function getDuplicates(array, integer) {
  const lookup = array.reduce((a, e) => {
    a[e.id] = ++a[e.id] || 0;
    return a;
  }, {});

  return array.filter(e => lookup[e.id] === (integer - 1))
}

export function getUniques(array) {
  return array.filter((item, pos) => array.indexOf(item) === pos)
}

export function setUrlParams(parameters) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search.slice(1));

  parameters.forEach(({ name, value }) => {
    if (value != '') params.set(name, encodeURIComponent(value));
    else params.delete(name);
  });

  window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
}

function getProductPromises() {
  const { size, endpoint } = app.getState().filter.config;

  const allPromises = [];
  const productsPerPage = 1000;
  const pagesToIterate = Math.ceil(parseInt(size) / productsPerPage);

  const params = new URLSearchParams(endpoint);

  for (let i = 0; i < pagesToIterate; i++) {
    params.set('page', i + 1)
    allPromises.push(fetch(decodeURIComponent(params.toString())));
  }

  return allPromises;
}

function generateProductArray(promisesArr) {
  return Promise.all(promisesArr).then((responses) => Promise.all(responses.map((res) => res.json()))).then((data) => {
    data = [].concat.apply([], data);
    return data;
  });
}

export async function fetchProducts() {
  const { id } = app.getState().filter.config;

  const productPromises = getProductPromises();
  const productsInSeperateArrays = await generateProductArray(productPromises);

  let allProducts = [];

  productsInSeperateArrays.forEach((arr) => {
    allProducts = [...allProducts, ...arr.products.filter((p) => p.published_at)];
  });

  const array = [
    allProducts.filter(item => item.available),
  ];

  if (id) array.push(array[0]);

  return Promise.all(array).then(([products, sortedProducts]) => {
    const prices = products.map((p) => Number(p.variants[0].price));

    app.emit('filter:loaded', ({ filter }) => ({
      filter: {
        ...filter,
        products: sortProducts('best-selling', products, sortedProducts || products),
        sorted: sortedProducts || products,
        prices: {
          min: Math.min(...prices),
          max: Math.max(...prices),
        },
      },
    }));
  });
}

export function sortProducts(value, array, sortedArray) {
  const { filter } = app.getState();

  const clonedArray = [...array || filter.products];
  const sorted = sortedArray || filter.sorted;

  switch (value) {
    case 'relevance':
    case 'best-selling':
      sortByArray(clonedArray, sorted.map((p) => p.id), 'id');
      break;

    case 'manual':
      sortByArray(clonedArray, sorted.map((p) => p.id), 'id');
      break;

    case 'title-ascending':
      clonedArray.sort(({ title: a }, { title: b }) => compare(a.toUpperCase(), b.toUpperCase(), 1));
      break;

    case 'title-descending':
      clonedArray.sort(({ title: a }, { title: b }) => compare(a.toUpperCase(), b.toUpperCase(), -1));
      break;

    case 'price-ascending':
      clonedArray.sort(({ variants: [{ price: a }] }, { variants: [{ price: b }] }) => Number(a) - Number(b));
      break;

    case 'price-descending':
      clonedArray.sort(({ variants: [{ price: a }] }, { variants: [{ price: b }] }) => Number(b) - Number(a));
      break;

    case 'created-ascending':
      clonedArray.sort(({ created_at: a }, { created_at: b }) => new Date(a).getTime() - new Date(b).getTime());
      break;

    case 'created-descending':
      clonedArray.sort(({ created_at: a }, { created_at: b }) => new Date(b).getTime() - new Date(a).getTime());
      break;

    default:
      console.error(`No sorting function for ${value}`);
      break;
  }

  return clonedArray;
}

function resetPagination() {
  const { filter } = app.getState();
  app.hydrate({ filter: { ...filter, page: 1 } });
}

function initFilters(filter, config) {
  const { type, name, listType } = filter.dataset;
  let items = [...filter.querySelectorAll(config.filterItems || '[data-filter-item]')];

  const obj = {
    type,
    name,
    async: filter.dataset.async != undefined,
    dynamic: filter.dataset.dynamic != undefined,
  };

  const findEligibleProducts = (array) => getUniques([...array].map((p) => {
    const [key, subKey] = obj.type.split('.');
    if (subKey) return p[key].map((s) => s[subKey]);
    return p[key];
  }).flat(1));

  const bindItemsEvent = () => {
    obj.items = items;
    items.forEach((item) => {
      const input = item.tagName == 'INPUT';

      item.addEventListener(input ? 'change' : 'click', () => {
        if (!input) item.classList.toggle(config.activeClass || 'active');
        app.emit('filter:start');
      });
    });
  };

  if (obj.async) {
    app.on('filter:loaded', (state) => {
      const { products } = state.filter;

      const asyncFilterItems = findEligibleProducts(products);

      filter.innerHTML = config.render && config.render[listType] ? asyncFilterItems.map(config.render[listType]).join('') : null ?? `Please add a renderFunction, for ${listType} in your filter settings`;
      items = [...filter.querySelectorAll(config.filterItems || '[data-filter-item]')];
      bindItemsEvent();
    });
  } else {
    bindItemsEvent();
  }

  if (type == 'price') {
    app.on('filter:loaded', ({ filter }) => {
      obj.values = [filter.prices.min, filter.prices.max];
      items[0].min = filter.prices.min;
      items[0].max = filter.prices.max;
    });
  }

  if (obj.dynamic) {
    app.on('filter:query', (state, query) => {
      const allButCurrentFilters = query.filter((q) => q.params.length && q.name != obj.name);
      const allProducts = [].concat(...allButCurrentFilters.map((q) => q.products));
      const products = getUniques(getDuplicates(allProducts, allButCurrentFilters.length));
      const possible = findEligibleProducts(products);

      obj.items.map((item) => {
        item.style.display = !possible.includes(item.dataset.value) && possible.length && !item.classList.contains(config.activeClass || 'active') ? 'none' : null;
      });
    });
  }

  return obj;
}

function createQuery(state, paginate) {
  const { filters, products } = state.filter;
  const { activeClass } = state.filter.config.selectors;

  const query = [];

  if (!paginate) resetPagination();

  filters.forEach((filter) => {
    const obj = {
      ...filter,
    };

    obj.activeItems = filter.items.filter((i) => i.classList.contains(activeClass));

    if (filter.type == 'price') {
      const [min, max] = filter.values;
      obj.params = [Number(filter.items[0].dataset?.min ?? min), Number(filter.items[0].dataset?.max ?? max)];
    } else if (filter.name == 'colors') {
      obj.labels = obj.activeItems.map((i) => i.dataset.label)
      const childs = obj.activeItems.map((i) => i.dataset.childs)

      obj.params = childs.length ? childs.join().split(',') : []
    }
    else obj.params = obj.activeItems.map(i => i.dataset.value || Number(i.value))

    obj.products = obj.params.length == 0 ? products : products.filter((product) => {
      const [key, subKey] = filter.type.split('.');
      const [min, max] = obj.params;
      const [variant] = product.variants;

      if (obj.type === 'product_type' && obj.params.find(p => product[key] === p)) return product
      else if (obj.type != 'product_type' && obj.type != 'color' && obj.params.filter(p => product[key] ? product[key].includes(p) : '').length) return product
      else if (obj.type == 'color' && product[key].split(' ').filter(p => obj.params.includes(p)).length) return product
      else if (subKey && product[key].filter(s => obj.params.filter(p => s[subKey].includes(p)).length).length) return product
      else if (filter.type == 'price' && Number(variant[key]) >= min && Number(variant[key]) <= max) return product

    });

    query.push(obj);
  });

  app.emit('filter:query', null, query);
}

function queryProducts(state, query) {
  const { filters } = state.filter;

  let totalProducts = [];

  query.forEach((q) => {
    totalProducts = [...totalProducts, ...q.products];
  });

  totalProducts = getDuplicates(totalProducts, filters.length);
  totalProducts = getUniques(totalProducts);

  const params = query.map((q) => ({
    name: q.name,
    value: q.name === 'colors' ? q.labels.join(',') : q.params.join('+'),
  }));

  setUrlParams(params);
  // setUrlParams(query.map(q => ({ name: q.name, value: q.params.join('+') })))

  app.emit('filter:render', ({ filter }) => ({ filter: { ...filter, query, pagination: { limit: totalProducts.length, showing: Math.max(0, Math.min(filter.page * filter.config.paginate, totalProducts.length)) } } }), totalProducts);
}

function renderProducts(state, products) {
  const { config, page, query } = state.filter;
  const pageAmount = config.paginate * page;

  let renderedProducts = sortProducts(config.sorting.value || 'best-selling', [...products]);

  // Sort products by variant options and availability
  const variantOptionsFilter = query.filter(q => q.type === 'variants.title')

  if (variantOptionsFilter && variantOptionsFilter[0].params.length) {
    const filter = variantOptionsFilter[0]
    const [key, subKey] = filter.type.split('.')
    const params = filter.params

    let sortedProducts = renderedProducts.reverse().sort((a, b) => {

      // Find related variant based on variant options, from currently active variant filters
      const findVariant = (item) => (params.map(param => item[key].find(variant => variant['options'].map(option => option.value).filter(values => values === param).length)))

      // See if any variants is available in based on above active filter
      const variantMatchA = findVariant(a).some(variant => variant?.available ?? false)
      const variantMatchB = findVariant(b).some(variant => variant?.available ?? false)

      return variantMatchB > variantMatchA ? 1 : -1
    })

    renderedProducts = sortedProducts
  }

  renderedProducts.length = pageAmount;
  config.output.innerHTML = renderedProducts.map(config.productItem).join('');

  app.emit('filter:rendered', ({ products }));
}

function initSorting() {
  const { config } = app.getState().filter;

  setUrlParams([{ name: 'sort_by', value: config.sorting.value }]);

  config.sortingTriggers.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      config.sortingTriggers.forEach((item) => item.classList.remove(config.selectors.activeClass));
      item.classList.add(config.selectors.activeClass);

      const selection = [...config.sorting.options].findIndex((option) => option.value == item.dataset.value);
      config.sorting.selectedIndex = selection;

      // Manually trigger change event
      const event = document.createEvent('HTMLEvents');
      event.initEvent('change', true, false);
      config.sorting.dispatchEvent(event);
    });
  });

  config.sorting.addEventListener('change', () => {
    setUrlParams([{ name: 'sort_by', value: config.sorting.value }]);
    app.emit('filter:start', null, true);
  });
}

function initPagination() {
  const { config } = app.getState().filter;
  const { element, type } = config.pagination;

  let listener
  let shouldEmit = true

  app.on('filter:render', ({ filter }, products) => {
    shouldEmit = (filter.page * config.paginate) >= products.length ? false : true
    element.style.display = (filter.page * config.paginate) >= products.length ? 'none' : null
    setUrlParams([{ name: 'page', value: filter.page }])
  })

  const emit = () => {
    app.emit('filter:start', ({ filter }) => ({ filter: { ...filter, page: ++filter.page } }), true)
  }

  switch (type) {
    case 'button':
      element.addEventListener('click', emit);
      break;

    case 'infinite':
      listener = vsbl(element, { threshold: -1.5 })(() => shouldEmit && emit());
      break;

    default:
      break;
  }
}

function readUrlParams() {
  const { config } = app.getState().filter;
  const urlParams = new URLSearchParams(location.search);

  for (const [name, value] of urlParams) {
    // const values = decodeURIComponent(value).split('+');
    const splitCharacter = name == 'colors' ? ',' : '+';
    const values = decodeURIComponent(value).split(splitCharacter);
    const filter = config.element.querySelector(`${config.selectors.filter}[data-name="${name}"]`);

    const [item, ...items] = filter ? [...filter.querySelectorAll(config.selectors.filterItem)] : [];

    if (filter) for (let v of values) !items.length ? item.value = v : filter.querySelector(`${config.selectors.filterItem}[data-value="${v}"]`).classList.add(config.selectors.activeClass)

    if (name === 'price') {
      const [min, max] = values
      item.dataset.min = min
      item.dataset.max = max
    }
  }

  app.emit('filter:start', null, true);
}

export default function grafikrFilter(element, config = {}) {
  const filters = [...element.querySelectorAll(config.filters || '[data-filter]')].map((f) => initFilters(f, config));

  app.hydrate({
    filter: {
      config: {
        ...config,
        output: element.querySelector('[data-output]') || element,
        element: element,
        store: Shopify.shop.replace('.myshopify.com', ''),
        limit: Math.min(config.limit, 250) || 250,
        paginate: config.paginate || 16,
        selectors: {
          filter: config.filters || '[data-filter]',
          filterItem: config.filterItems || '[data-filter-item]',
          activeClass: config.activeClass || 'active',
        },
        pagination: {
          element: config.pagination.element || element.querySelector(config.pagination.element || '[data-pagination]'),
          type: config.pagination && config.pagination.type || 'button',
        },
        sorting: element.querySelector(config.sorting || '[data-filter-sorting]'),
        sortingTriggers: element.querySelectorAll(config.sortingTriggers || '[data-sorting-trigger]'),
      },
      filters: filters,
      page: Number(new URLSearchParams(location.search).get('page')) || 1,
    },
  });

  app.on('filter:loaded', ({ filter }) => {
    initPagination();
    readUrlParams();
    if (filter.config.sorting) initSorting();
  });

  app.on('filter:start', createQuery);
  app.on('filter:query', queryProducts);
  app.on('filter:render', renderProducts);

  fetchProducts();
}
